var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.75C4.86193 7.75 4.75 7.86193 4.75 8V21C4.75 21.1381 4.86193 21.25 5 21.25H19C19.1381 21.25 19.25 21.1381 19.25 21V8C19.25 7.86193 19.1381 7.75 19 7.75H5ZM3.25 8C3.25 7.0335 4.0335 6.25 5 6.25H19C19.9665 6.25 20.75 7.0335 20.75 8V21C20.75 21.9665 19.9665 22.75 19 22.75H5C4.0335 22.75 3.25 21.9665 3.25 21V8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.75C10.4812 2.75 9.25 3.98122 9.25 5.5V9C9.25 9.41421 8.91421 9.75 8.5 9.75C8.08579 9.75 7.75 9.41421 7.75 9V5.5C7.75 3.15279 9.65279 1.25 12 1.25C14.3472 1.25 16.25 3.15279 16.25 5.5V9C16.25 9.41421 15.9142 9.75 15.5 9.75C15.0858 9.75 14.75 9.41421 14.75 9V5.5C14.75 3.98122 13.5188 2.75 12 2.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.0d3835eacba92bbf77741b20d5dc16a5.svg";
export { ForwardRef as ReactComponent };